export enum TripType {
    route = 1,
    connection = 2,
    open = 3
}